import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-hotel-deals-req-alert-modal',
  templateUrl: './hotel-deals-req-alert-modal.component.html',
  styleUrls: ['./hotel-deals-req-alert-modal.component.scss'],
})
export class HotelDealsReqAlertModalComponent implements OnInit {
  @Input() descriptionText: string;

  constructor(private modalController: ModalController) {}

  ngOnInit() {
  }

  closeModal() {
    this.modalController.dismiss();
  }
}
